import React from "react";
import * as Styles from "../common/styles/ResultsAem";
import { TradeInAemLabel, useTradeInAemLabel } from "../../../utils/labels";
import { useTradeInAemSelector } from "../../../redux/store";
import { trackSummaryDealerAction } from "../../../utils/tracking";

import useTrackingParams from "../../../hooks/useTrackingParams";

const TradeInAemSummaryDealerBlock = (): JSX.Element | null => {
    const dealer = useTradeInAemSelector((state) => state.tradeInAemDealer.dealer);
    const tradeInAemModelSelect = useTradeInAemSelector((state) => state.tradeInAemModelSelect);
    const dealerAddressLabel = useTradeInAemLabel("tradeInAemContactDealerAddress", dealer?.address);
    const trackingParams = useTrackingParams();

    if (!dealer) return null;

    return (
        <>
            <Styles.Title>
                <TradeInAemLabel label="tradeInAemSummaryYourRetailer" />
            </Styles.Title>
            <Styles.Card>
                <Styles.CardBody py={{ xs: 2, lg: 2 }}>
                    <div>
                        <Styles.CardTitle mb={1}>{dealer.name}</Styles.CardTitle>
                        <Styles.CardAddress>{dealerAddressLabel.replace(/\\n/g, "\n")}</Styles.CardAddress>
                    </div>
                    <div>
                        {dealer.email && (
                            <div>
                                <a
                                    href={`mailto:${dealer.email}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={() =>
                                        trackSummaryDealerAction(trackingParams, tradeInAemModelSelect, "email")
                                    }
                                >
                                    {dealer.email}
                                </a>
                            </div>
                        )}
                        {dealer.website && (
                            <div>
                                <a
                                    href={dealer.website}
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={() =>
                                        trackSummaryDealerAction(trackingParams, tradeInAemModelSelect, "site")
                                    }
                                >
                                    {dealer.website}
                                </a>
                            </div>
                        )}
                        {dealer.phoneNumber && (
                            <div>
                                <a
                                    href={`tel:${dealer.phoneNumber}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={() =>
                                        trackSummaryDealerAction(trackingParams, tradeInAemModelSelect, "call")
                                    }
                                >
                                    <TradeInAemLabel
                                        label="tradeInAemSummaryPhone"
                                        params={{ value: dealer.phoneNumber }}
                                    />
                                </a>
                            </div>
                        )}
                    </div>
                </Styles.CardBody>
            </Styles.Card>
        </>
    );
};
export default TradeInAemSummaryDealerBlock;
